import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DeleteForeverSharpIcon from "@mui/icons-material/DeleteForeverSharp";

function ProductRow({ product, forceOpen, deleteProduct }) {
  const [open, setOpen] = React.useState(false);
  const isOpen = forceOpen || open;
  return (
    <React.Fragment>
      <TableRow>
        <TableCell sx={{ width: "0px" }}>
          {" "}
          {/* Fixed width for icon */}
          <IconButton
            className="no-print"
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              padding: "4px",
              "& svg": {
                fontSize: "22px", // Smaller icon
              },
            }}
          >
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          sx={{
            fontSize: "0.875rem", // Smaller font
            padding: "4px 8px",
          }}
        >
          {product.product_title}
        </TableCell>
        <TableCell
          align="right"
          sx={{
            fontSize: "0.875rem",
            padding: "4px 8px",
          }}
        >
          {product.variants.length} variants
        </TableCell>
        <TableCell
          align="right"
          sx={{
            fontSize: "0.875rem",
            padding: "4px 8px",
          }}
        >
          {product.variants.reduce((sum, variant) => sum + variant.quantity, 0)}{" "}
          total
        </TableCell>
        <TableCell
          align="right"
          sx={{
            fontSize: "0.875rem",
            padding: "4px 8px",
          }}
        >
          <IconButton
            className="no-print"
            aria-label="expand row"
            size="small"
            onClick={() => deleteProduct(product.product_id)}
            sx={{
              padding: "4px",
              "& svg": {
                fontSize: "22px", // Smaller icon
              },
            }}
          >
            {<DeleteForeverSharpIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={5}>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box>
              <Table size="small" aria-label="variants">
                <TableHead>
                  <TableRow
                    sx={{
                      "& svg": {
                        fontSize: "0.40rem", // Smaller icon
                      },
                    }}
                  >
                    <TableCell>Sku</TableCell>
                    <TableCell>Barcode</TableCell>
                    <TableCell>Size</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {product.variants.map((variant) => (
                    <TableRow key={variant.id}>
                      <TableCell>{variant.laam_sku}</TableCell>
                      <TableCell>{variant.laam_barcode}</TableCell>
                      <TableCell>{variant.variant_title}</TableCell>
                      <TableCell align="right">{variant.quantity}</TableCell>
                      <TableCell align="right">PKR {variant.price}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function OrderDetailsTable({
  orderDetails,
  order,
  forceOpen,
  deleteProduct,
  printing,
}) {
  return (
    <div>
      <TableContainer
        sx={
          printing
            ? {
                fontSize: "0.65rem",
                "& .MuiTableCell-root": {
                  fontSize: "0.60rem",
                  py: 0.3,
                },
              }
            : { "& .MuiTableCell-root": { py: 0.5 } }
        }
      >
        <div className="d-flex justify-content-between">
          <h6>Order #{order.id}</h6>
          <p>Status: {order.status}</p>
          <p>Store ID: {order.store_id}</p>
          <p>Total Quantity: {order.total_qty}</p>
          <p>Total Price: Rs {order.total_price}</p>
        </div>
        <Table aria-label="collapsible order details table" small>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Product</TableCell>
              <TableCell align="right">Variants</TableCell>
              <TableCell align="right">Total Quantity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="print-product-wrapper">
            {orderDetails.map((product) => (
              <ProductRow
                key={product.product_id}
                product={product}
                forceOpen={forceOpen}
                deleteProduct={deleteProduct}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
